var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgElementDendro(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 314.09 314.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#a5c83b;}.cls-2{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_2",
    "data-name": "Livello 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Livello_10",
    "data-name": "Livello 10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M172.23,78.43,157.05,96.1,141.86,78.43A24,24,0,0,1,139.77,50l17.28-27.35L174.32,50A24,24,0,0,1,172.23,78.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M268.12,172.71l-.78.57.59.51c-6.93,39.22-38.21,56.42-56,64.94-20.11,9.62-54.86,29.44-54.86,52.75,0-23.31-34.76-43.13-54.87-52.75-17.8-8.52-49.08-25.72-56-64.93l.6-.52L46,172.7a93.47,93.47,0,0,1-1.21-15.29c0-51,40.52-73.45,65.87-73.45,19.14,0,33,11.45,38.59,17.07a5.05,5.05,0,0,1,.65,6.34l-4.07,6.25a2.42,2.42,0,0,1-3.93.18C136.59,107.14,120.7,91.66,93,102,72.29,109.75,59.33,129,59.33,152s14.21,56.43,51.41,70.22,46.31,36.08,46.31,36.08,9.11-22.29,46.31-36.08S254.77,175,254.77,152s-13-42.21-33.65-49.94c-27.72-10.36-43.62,5.12-48.9,11.78a2.42,2.42,0,0,1-3.93-.18l-4.07-6.25a5.07,5.07,0,0,1,.65-6.34C170.51,95.41,184.33,84,203.46,84c25.36,0,65.87,22.44,65.87,73.45A93.51,93.51,0,0,1,268.12,172.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.76,173.28l-.6.52c-.07-.36-.14-.73-.19-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M140.75,206.42c-31.67-27.84-39-46.35-31.82-63s27.13-9.94,27.13-9.94c-17.07-17.7-31.49-14.39-39.49-9.91a26.73,26.73,0,0,0-11,12c-6.5,13.75-.57,27.06,9.45,38.36-6.32.52-14.13,3.24-18.63,12.44,0,0,4.65-4.77,11-5.6s12.7-1.17,17.62,2.8h0C121.32,197.37,140.75,206.42,140.75,206.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M60.87,92.75A16.77,16.77,0,0,0,44.93,78.16l-20.36-.83,4.77,16.8a18.22,18.22,0,0,0,20,13.08l13.14-1.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.76,173.28l-.6.52-7.89,6.83a12,12,0,0,1-14.52.94l-10-6.6,10.47-7.71a12,12,0,0,1,14.23,0L46,172.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M268.12,172.71c-.05.36-.12.72-.19,1.08l-.59-.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M173.35,206.42c31.66-27.84,39-46.35,31.81-63S178,133.45,178,133.45c17.07-17.7,31.49-14.39,39.5-9.91a26.73,26.73,0,0,1,11,12c6.49,13.75.57,27.06-9.45,38.36,6.32.52,14.12,3.24,18.63,12.44,0,0-4.65-4.77-11-5.6s-12.7-1.17-17.62,2.8h0C192.78,197.37,173.35,206.42,173.35,206.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M253.22,92.75a16.79,16.79,0,0,1,15.94-14.59l20.37-.83-4.77,16.8a18.24,18.24,0,0,1-20,13.08l-13.14-1.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M300.3,175l-10,6.6a12,12,0,0,1-14.51-.94l-7.9-6.84-.59-.51.78-.57,7.48-5.48a12,12,0,0,1,14.24,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 314.09,
    height: 314.09
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElementDendro);
export default __webpack_public_path__ + "static/media/Element_Dendro.97c848cc4e28377348d86edf1d79fb2d.svg";
export { ForwardRef as ReactComponent };